var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"ma-auto text-center",attrs:{"flat":""}},[_c('p',{staticClass:"display-1 font-weight-bold"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"subtitle-1 font-weight-bold"},[_vm._v(_vm._s(_vm.message))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-036df2a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/error/Error.vue
// module id = 690
// module chunks = 1